import {
  Target,
  PenLine,
  Mail,
  Video,
  Building2,
  Mic2,
  IdCard,
  GraduationCap,
  BookOpen,
  School,
  PenSquare,
  Network,
  Layers,
  Clapperboard,
  CalendarClock,
  MapPin,
  Magnet,
  MessageSquareQuote,
  Briefcase,
  Sparkles,
  UsersRound,
  Workflow,
  ShieldCheck,
  BadgeCheck,
  Compass,
  BrainCircuit,
  Linkedin,
  Instagram,
  Youtube,
  ArrowRight,
  Phone,
  Quote,
} from "lucide-react";

const ICONS = {
  Target,
  PenLine,
  Mail,
  Video,
  Building2,
  Mic2,
  IdCard,
  GraduationCap,
  BookOpen,
  School,
  PenSquare,
  Network,
  Layers,
  Clapperboard,
  CalendarClock,
  MapPin,
  Magnet,
  MessageSquareQuote,
  Briefcase,
  Sparkles,
  UsersRound,
  Workflow,
  ShieldCheck,
  BadgeCheck,
  Compass,
  BrainCircuit,
  Linkedin,
  Instagram,
  Youtube,
  ArrowRight,
  Phone,
  Quote,
};

export default ICONS;
